export let UserTicketViewOption;
(function (UserTicketViewOption) {
  UserTicketViewOption["COMPANY"] = "COMPANY";
  UserTicketViewOption["PERSONAL"] = "PERSONAL";
})(UserTicketViewOption || (UserTicketViewOption = {}));
export let UserTicketStatusOption;
(function (UserTicketStatusOption) {
  UserTicketStatusOption["ALL"] = "ALL";
  UserTicketStatusOption["OPEN"] = "OPEN";
  UserTicketStatusOption["CLOSED"] = "CLOSED";
})(UserTicketStatusOption || (UserTicketStatusOption = {}));
// TODO: Lets try to build this out to list all possible thread channels here.
export let ThreadChannels;
(function (ThreadChannels) {
  ThreadChannels["FORMS"] = "FORMS";
  ThreadChannels["EMAIL"] = "EMAIL";
})(ThreadChannels || (ThreadChannels = {}));
export let FileUploadStatus;
(function (FileUploadStatus) {
  FileUploadStatus["PENDING"] = "pending";
  FileUploadStatus["UPLOADING"] = "uploading";
  FileUploadStatus["UPLOADED"] = "uploaded";
  FileUploadStatus["ERROR"] = "error";
})(FileUploadStatus || (FileUploadStatus = {}));
export let FileUploadError;
(function (FileUploadError) {
  FileUploadError["SIZE_OVERFLOW_ERROR"] = "SIZE_OVERFLOW_ERROR";
  FileUploadError["RATE_OVERFLOW_ERROR"] = "RATE_OVERFLOW_ERROR";
  FileUploadError["FILE_TYPE_NOT_SUPPORTED"] = "FILE_TYPE_NOT_SUPPORTED";
  FileUploadError["NO_THREAD"] = "NO_THREAD";
  FileUploadError["UPLOAD_FAILED"] = "upload_failed";
  FileUploadError["UPLOAD_ABORTED"] = "upload_aborted";
})(FileUploadError || (FileUploadError = {}));